import generateComponentTheme from './theme'
import generateStyle from './styles'
import {withStyle, Global} from '@instructure/emotion'
import { LoginForm } from '../LoginForm'

export const LoginPage = withStyle(generateStyle, generateComponentTheme)((props) => {
  return (
    <>
      <Global styles={props.styles.globalStyles} />
      <LoginForm {...props} />
    </>
  )
})